import React from 'react';
import './TrungBayGiaiThuong.css';
import prizeImage1 from '../assets/img/1 (2).png';
import prizeImage2 from '../assets/img/1 (4).jpeg';

const TrungBayGiaiThuong = () => {
  const prizes = [
    {
      tier: 'Đặc Biệt',
      amount: '10,000,000đ',
      icon: '👑',
      color: '#FFD700',
      image: prizeImage1
    },
    {
      tier: 'Giải Nhất',
      amount: '5,000,000đ',
      icon: '🥇',
      color: '#FFA500',
      image: prizeImage2
    },
    {
      tier: 'Giải Nhì',
      amount: '1,000,000đ',
      icon: '🥈',
      color: '#FF6347',
      image: prizeImage1
    },
    {
      tier: 'Giải Ba',
      amount: '500,000đ',
      icon: '🥉',
      color: '#00C853',
      image: prizeImage2
    },
    {
      tier: 'Khuyến Khích',
      amount: '100,000đ - 500,000đ',
      icon: '🎁',
      color: '#9C27B0',
      image: prizeImage1
    }
  ];

  return (
    <section className="prize-showcase">
      <div className="container">
        <h2 className="section-title">Bảng Giải Thưởng Hôm Nay</h2>
        <p className="section-subtitle">5 mức giải thưởng từ 100k đến 10 triệu đồng - Quay trúng đâu nhận đó!</p>
        
        <div className="prizes-grid">
          {prizes.map((prize, index) => (
            <div key={index} className="prize-card" style={{ '--prize-color': prize.color }}>
              <div className="prize-image-wrapper">
                <img src={prize.image} alt={`Giải ${prize.tier}`} loading="lazy" />
                <div className="prize-overlay"></div>
              </div>
              <div className="prize-content">
                <div className="prize-icon">{prize.icon}</div>
                <div className="prize-tier">{prize.tier}</div>
                <div className="prize-amount">{prize.amount}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrungBayGiaiThuong;

